<template>
    <v-layout align-start>
        <v-flex>
            <v-data-table
                :headers="headers"
                :items="cMensajeusuarios"
                :search="search"
                :expanded.sync="expanded"
                :single-expand="true"
                class="elevation-1"
                :loading="loading"
                :options.sync="options"
                :server-items-length="totalItems"
                >
                <template v-slot:top>
                    <v-toolbar flat color="white">
                    <v-toolbar-title>Usuarios mensajes</v-toolbar-title>
                    <v-divider
                        class="mx-4"
                        inset
                        vertical
                    ></v-divider>
                    <v-spacer></v-spacer>
                    <v-text-field class="text-xs-center" 
                        v-model="search" 
                        append-icon="search" 
                        @click:append="GetMensajeUsuario"
                        @keyup.enter="GetMensajeUsuario"
                        label="Busqueda" 
                        single-line hide-details></v-text-field>
                    <v-spacer></v-spacer>
                    <!-- ********** -->
                    <v-dialog v-model="dialog" fullscreen 
                        hide-overlay transition="dialog-bottom-transition">
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" 
                                dark v-on="on" 
                                @click="newItem"
                                outlined>Crear Usuario Comunicado</v-btn>
                        </template>
                        <v-card>
                            <v-toolbar dark color="primary">
                                <v-btn icon dark @click="dialog = false">
                                    <v-icon>close</v-icon>
                                </v-btn>
                                <v-toolbar-title>
                                    <span class="headline">
                                        Mensaje Usuarios
                                    </span>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-toolbar-items>
                                    <v-btn dark text @click="newItem">Limpiar Controles</v-btn>
                                </v-toolbar-items>
                                <!-- <v-btn class="ma-2" @click="Limpiar()" outlined color="indigo">Limpiar Controles</v-btn> -->
                                <v-spacer></v-spacer>
                                <v-toolbar-items>
                                    <v-btn 
                                        @click="saveItem"
                                        dark text>
                                        Grabar
                                    </v-btn>
                                </v-toolbar-items>
                            </v-toolbar>
                            <v-list three-line subheader>
                                <!-- <v-subheader><strong> Seleccione Tipo de grupo</strong></v-subheader> -->
                                <v-container fluid>
                                    <v-row>
                                        <v-col cols="12" sm="12" md="6">
                                            <v-autocomplete
                                                v-model="editedItem.idGrupo"
                                                :items="catGrupos"
                                                :filter="customFilterGrupo"
                                                color="white"
                                                item-text="nombre"
                                                item-value="idGrupo"
                                                label="Grupo"
                                                multiple
                                            ></v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" lg="4">
                                            <v-autocomplete
                                                v-model="editedItem.idNotificacion"
                                                :items="catComunicado"
                                                :filter="customFilterCom"
                                                color="white"
                                                item-text="titulo"
                                                item-value="idMensaje"
                                                label="Comunicado"
                                            ></v-autocomplete>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-list>
                        </v-card>
                        <v-divider></v-divider>
                    </v-dialog>
                    <!-- ********** -->
                    </v-toolbar>
                </template>
                <template v-slot:body="{ items }">
                    <tbody>
                        <tr v-for="item in items" :key="item.name">
                            <td>
                                <div>
                                    <v-icon small class="mr-2" 
                                        v-show="false"
                                        @click="editItem(item)">
                                        edit
                                    </v-icon>
                                    <v-icon small @click="deleteItem(item)">
                                        delete
                                    </v-icon>
                                </div>
                            </td>
                            <td>{{ item.nombre }}</td>
                            <td>
                                {{ item.titulo }}
                                <v-icon 
                                    v-if="item.idTipoMensaje === 1"
                                    @click="VerTipo(item)">
                                    textsms
                                </v-icon>
                                <v-icon 
                                    v-if="item.idTipoMensaje === 2"
                                    @click="VerTipo(item)">
                                    insert_photo
                                </v-icon>
                                <v-icon 
                                    v-if="item.idTipoMensaje === 3"
                                    @click="VerTipo(item)">
                                    picture_as_pdf
                                </v-icon>
                            </td>
                            <td>{{ item.fechaInicio }}</td>
                            <td>{{ item.fechaFin }}</td>
                             <td>
                                <v-icon class="mr-2">
                                    {{ item.vigencia ? 'done_outline' : 'highlight_off' }}
                                </v-icon>
                            </td>
                        </tr>
                    </tbody>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">More info about {{ item.name }}</td>
                </template>
                <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">Resetear</v-btn>
                </template>
            </v-data-table>

            <v-dialog 
                v-model="vDialogTipo" 
                fullscreen 
                hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="vDialogTipo = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>{{vShowTipo.sTipoMensaje}}</v-toolbar-title>
                        <v-spacer></v-spacer>            
                    </v-toolbar>
                    <v-list three-line subheader>
                        <v-list-item>
                        <v-list-item-content v-show="vShowTipo.idTipoMensaje === 1">
                            <v-list-item-title>{{vShowTipo.titulo}}</v-list-item-title>
                            <v-list-item-subtitle>{{vShowTipo.mensaje}}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-content v-show="vShowTipo.idTipoMensaje === 2">
                            <v-list-item-title>{{vShowTipo.titulo}}</v-list-item-title>
                            <v-list-item-subtitle>
                                <iframe :src="vShowTipo.path" style="width:100%;height:700px;"></iframe>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-content v-show="vShowTipo.idTipoMensaje === 3">
                            <v-list-item-title>{{vShowTipo.titulo}}</v-list-item-title>
                            <v-list-item-subtitle>
                                <iframe :src="vShowTipo.path" style="width:100%;height:700px;"></iframe>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        </v-list-item>            
                    </v-list>                    
                </v-card>
            </v-dialog>
        </v-flex>
    </v-layout>
</template>

<script>
import moment from 'moment'
export default {
    name: 'comunicadousuario',
    components: {
    },
    data () {
        return {
            cMensajeusuarios:[],
            catUsuarios: [],
            catGrupos: [],
            catComunicado: [],
            expanded: [],

            editedItem: {},
            dialogFecha: false,

            vShowTipo: {},
            vDialogTipo: false,
            
            options: {},
            totalItems: 1000,
            page: 1,
            pageCount: 0,
            loading: false,
            consultaDto: {
                Skip: 0,
                Take: 10,
                descending: true,
                sortBy: '',
                search: '',
                extraParam: '3'
            },
            consultaDtoUser: {
                Skip: 0,
                Take: 100,
                descending: true,
                sortBy: '',
                search: ''
            },

            dialog: false,
            headers: [
                { text: 'Acciones', value: ' ' },
                { text: 'Usuarios', value: 'Usuarios' },
                { text: 'Mensaje', value: 'mensaje' },
                { text: 'Fecha Inicio', value: 'FechaInicio' },
                { text: 'Fecha Fin', value: 'FechaFin' },
                { text: 'Vigencia', value: 'vigencia' },
            ],
            rulesIMG: [
                value => !value || value.size < 2000000 || 'La imagen no puede ser mayor de 2 MB!',
            ],
            rulesPDF: [
                value => !value || value.size < 2000000 || 'El PDF no puede ser mayor de 2 MB!',
            ],
            files: null,
            search: '',
        }
    },
    computed: { },
    watch: {
        options: {
            handler () {
                this.GetMensajeUsuario()
                    // .then(data => {
                    //     this.desserts = data.items
                    //     this.totalDesserts = data.total
                    // })
            },
            deep: true
        }
    },
    created () { },
    mounted () {
        this.Default()
    },
    filters: {
        formatDate (date) {
            return moment(date).format('L')
        }
    },
    methods: {
        Default () {
            let me = this
            me.$store.dispatch('setIsBusy', true)
            me.GetMensajeUsuario()
            me.$axios.post('api/Usuario/Get', me.consultaDto)
                .then(r => {
                    if (r.data.exito) {
                        me.catUsuarios = r.data.datos
                    }
                    // this.$root.Mensaje(r.data.mensaje)
                    me.$store.dispatch('setIsBusy', false)
                })
                .catch(e => { console.log(e) })
            me.$axios.get('api/Grupos/Get')
                .then(r => {
                    if (r.data.exito) {
                        me.catGrupos = r.data.datos
                    }
                })
                .catch(e => { console.log(e) })
            me.$axios.get('api/Comunicados/Listar')
                .then(r => {
                    me.catComunicado = r.data
                })
                .catch(e => { console.log(e) })
        },
        customFilterGrupo (item, queryText, itemText) {
            const textOne = item.nombre.toLowerCase()
            const searchText = queryText.toLowerCase()
            let r = textOne.indexOf(searchText) > -1 
            return r
        },
        customFilterCom (item, queryText, itemText) {
            const textOne = item.mensaje.toLowerCase()
            const searchText = queryText.toLowerCase()
            let r = textOne.indexOf(searchText) > -1 
            return r
        },
        GetMensajeUsuario () {
            var me = this
            debugger
            // console.log(this.itemsPerPage)
            const { sortBy, sortDesc, page, itemsPerPage } = this.options
            var skip = (page - 1) * itemsPerPage
            console.log(skip)
            // console.log(page)
            // console.log(itemsPerPage)
            
            this.loading = true
            me.consultaDto.Skip = skip
            me.consultaDto.Take = itemsPerPage
            me.consultaDto.search = me.search
            me.$axios.post('api/MensajeUsuario/Get', me.consultaDto)
                .then(r => {
                    if (r.data.exito) {
                        me.totalItems = parseInt(r.data.mensaje)
                        // console.log('this.totalItems')
                        // console.log(this.totalItems)
                        var tempCat = r.data.datos
                        me.cMensajeusuarios = []
                        for (var i = 0; i < tempCat.length; i++) {
                            var item = tempCat[i]
                            item.path = me.SetPath(item.path)                            
                            item.fechaInicio = moment(item.fechaInicio).format('L')
                            item.fechaFin = moment(item.fechaFin).format('L')                            
                            me.cMensajeusuarios.push(item)
                        }
                        me.newItem()
                    }
                    this.loading = false
                })
                .catch(e => { console.log(e) })
        },
        newItem () {
            let me = this
            me.$axios.get('api/MensajeUsuario/New')
                .then(r => {
                    me.editedItem = r.data
                })
                .catch(e => { console.log(e) })
        },
        editItem (item) {
            this.editedItem = item
            this.dialog = true
        },
        deleteItem (item) {
            let me = this
            me.$store.dispatch('setIsBusy', true)
            console.log('item.idMensajeUsuario')
            console.log(item.idMensajeUsuario)
            me.$axios.get('api/MensajeUsuario/Delete?idMensajeUsuario=' + item.idMensajeUsuario)
                .then(s => {
                    me.$root.Mensaje(s.data.mensaje)
                    me.$store.dispatch('setIsBusy', false)
                    me.dialog = false
                    me.GetMensajeUsuario()
                })
                .catch(e => {                     
                    this.$root.Mensaje(e)
                })
         },
        saveItem () {
            let me = this
            me.$store.dispatch('setIsBusy', true)
            var editItem = {
                "idGrupo": me.editedItem.idGrupo,
                "idUsuario": me.editedItem.idUsuario,
                "idNotificacion": me.editedItem.idNotificacion
            }
            console.log('editItem')
            console.log(editItem)
            me.$axios.post('api/MensajeUsuario/Save', editItem)
                .then(s => {
                    if(s.data.exito) {
                        me.$root.Mensaje('Mensaje grupo asignado')
                    } else {
                        me.$root.Mensaje(s.data.mensaje)
                    }
                    me.GetMensajeUsuario()
                    me.$store.dispatch('setIsBusy', false)
                    me.dialog = false
                })
                .catch(e => { 
                    console.log(e)
                    this.$root.Mensaje(e)
                })
        },
        VerTipo (comunicado) {
            // this.vShowTipo = comunicado
            // this.vDialogTipo = true
            window.open(
              comunicado.path,
              '_blank'
            );
        },
        SetPath (urlServer) {
            var url = ''
            var cadena = urlServer
            var u1 = this.$uriApImg
            // 'http://apicontigo.cosmic.mx/FileMessage'
            if (cadena === undefined || cadena === '' || cadena === null)
                return ''

            var arr = cadena.split('FileMessage')
            if (arr.length > 0) {
                url = u1 + arr[1]
                //console.log(url)
            }
            return url
        }
    }
}
</script>
